(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProviderCategoryController', ProviderCategoryController);

    ProviderCategoryController.$inject = ['$state', 'ProviderCategory', 'ProviderCountry', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ProviderCategoryController($state, ProviderCategory, ProviderCountry, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.providerCountries = ProviderCountry.getAsList();
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.searchQuery = {
            countryId: pagingParams.countryId,
            name: pagingParams.name,
            providerId: pagingParams.providerId,
            status: pagingParams.status
        };
        if (!pagingParams.firstRun) {
            loadAll();
        }

        function loadAll () {
            ProviderCategory.query({
                name: pagingParams.name,
                countryId: pagingParams.countryId,
                status: pagingParams.status,
                providerId: pagingParams.providerId,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.providerCategories = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                name: vm.searchQuery.name,
                countryId: vm.searchQuery.countryId,
                status: vm.searchQuery.status,
                providerId: vm.searchQuery.providerId,
                firstRun: false
            });
        }
        function search(searchQuery) {
            vm.links = null;
            vm.page = 1;
            vm.predicate = pagingParams.predicate;
            vm.reverse = pagingParams.ascending;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = pagingParams.predicate;
            vm.reverse = pagingParams.ascending;
            vm.searchQuery = {
                name: null,
                countryId: null,
                status: null,
                providerId: null
            };
            vm.transition();
        }
    }
})();
